// Generated by CoffeeScript 2.4.1
(function() {
  var SocketController, Weaver, WeaverBase;

  WeaverBase = require('../Weaver');

  SocketController = require('../SocketControllerWithStream');

  Weaver = class Weaver extends WeaverBase {
    constructor(opts) {
      super(opts);
      Weaver.instance = this;
      this.File = Weaver.File;
      this.Plugin = Weaver.Plugin;
      this.coreManager = new Weaver.CoreManager(SocketController);
    }

  };

  module.exports = Weaver;

  if (typeof window !== "undefined" && window !== null) {
    window.Weaver = Weaver; // Browser
  }

  module.exports.Plugin = require('../WeaverPlugin');

  module.exports.File = require('../WeaverFile');

}).call(this);
